import { ListBuilderTableColumns } from "../enum/list-builder-table-columns";

export const listBuilderTableColumns = [
    {
        id: ListBuilderTableColumns.LIST_BUILDER_NAME,
        name: "Name",
        width: 100,
        sortable: true,
    },
    {
        id: ListBuilderTableColumns.STATUS,
        name: "Status",
        width: 70,
        sortable: true,
    },
    {
        id: ListBuilderTableColumns.LAST_BUILD,
        name: "Last Build",
        width: 80,
        sortable: true,
    },
    {
        id: ListBuilderTableColumns.BUILD_LIST_BUTTON,
        name: "Build",
        width: 45,
        sortable: false,
        icon: "/assets/build.svg",
    },
    {
        id: ListBuilderTableColumns.DOWNLOAD_BUTTON,
        name: "Download",
        width: 50,
        sortable: false,
        icon: "/assets/download-icon.svg",
    },
    {
        id: ListBuilderTableColumns.EDIT_BUTTON,
        name: "Edit",
        width: 40,
        sortable: false,
        icon: "/assets/edit.svg",
    },
    {
        id: ListBuilderTableColumns.DUPLICATE_BUTTON,
        name: "Duplicate",
        width: 50,
        sortable: false,
        icon: "/assets/duplicate.svg",
    },
    {
        id: ListBuilderTableColumns.DELETE_BUTTON,
        name: "Delete",
        width: 50,
        sortable: false,
        icon: "/assets/delete.svg",
    },
];
